// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file auth/auth_requests.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file auth/auth_requests.proto.
 */
export const file_auth_auth_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChhhdXRoL2F1dGhfcmVxdWVzdHMucHJvdG8SFGNvbS5nZW0udmNzLmNvbnRyYWN0IkUKDExvZ2luUmVxdWVzdBIQCgh1c2VybmFtZRgBIAEoCRIRCgljaGFubmVsSWQYAiABKAkSEAoIZGV2aWNlSWQYAyABKAkiKwoTUmVmcmVzaFRva2VuUmVxdWVzdBIUCgxyZWZyZXNoVG9rZW4YASABKAlCGAoUY29tLmdlbS52Y3MuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.vcs.contract.LoginRequest
 */
export type LoginRequest = Message<'com.gem.vcs.contract.LoginRequest'> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string channelId = 2;
   */
  channelId: string;

  /**
   * @generated from field: string deviceId = 3;
   */
  deviceId: string;
};

/**
 * Describes the message com.gem.vcs.contract.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_requests, 0);

/**
 * @generated from message com.gem.vcs.contract.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<'com.gem.vcs.contract.RefreshTokenRequest'> & {
  /**
   * @generated from field: string refreshToken = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message com.gem.vcs.contract.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_requests, 1);
